
import * as s from './style'

type Props = {
    readonly children: any;
}

const Layout: React.FC<Props> = ({children}) => {
    return(
        <s.layout>
            {children}
        </s.layout> 
    )
}

export default Layout